<template>
  <div class="main RouteView">
    <!-- 开发环境 -->
    <div v-if="isDebug">
      <keep-alive v-if="refreshByTabLayout">
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <!-- 生产环境 -->
    <div v-else>
      <keep-alive :exclude="noKeepAlive">
        <router-view :key="key" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'RouteView',
  data() {
    return {
      isDebug: window._CONFIG['isDebug'] ? true : false,
      refreshByTabLayout: true,
    }
  },
  computed: {
    noKeepAlive() {
      return this.$store.state.app.noKeepAlive
    },
    key() {
      return this.$route.path
    },
  },
  watch: {
    $route: function (newRoute) {},
  },
  methods: {
    forchRefresh() {
      this.refreshByTabLayout = false
      this.$nextTick(() => {
        this.refreshByTabLayout = true
      })
    },
  },
}
</script>
